<template>
  <cozyCornerHome />
</template>

<script>
  import cozyCornerHome from "./views/cozyCorner-Home"

  export default {
   name: 'App',
   components: {
     cozyCornerHome,
    },
  };
</script>

<style>

</style>
